// Morse Code Tool — translate text to and from Morse code.
import { m } from "@/paraglide/messages";
import type { Tool } from "../index";

export const morseCodeTool: Tool = {
  id: "morse-code",
  name: () => m.mc_tool_name(),
  description: () => m.mc_tool_description(),
  icon: "📡",
  basePath: "/morse-code",
  status: "stable",
  tags: ["morse", "code", "translator", "fun"],
  pages: [
    {
      name: () => m.mc_nav_main(),
      path: "/morse-code",
      description: () => m.mc_nav_main_desc(),
      icon: "📡",
    },
  ],
};
